import { createCache } from '@ant-design/cssinjs';

export const antdCache = createCache();
